<template lang="pug">
div.pad.font14
  app-divider(label="Imóvel")
  div.pad
    informacoes-imovel.pad-top(:cadastroOriginal="cadastroOriginal")
    informacoes-destinacao-uso-imovel(:destinacaoUsoImovel="imovel.destinacaoUsoImovel")
</template>
<script>
import informacoesDestinacaoUsoImovel from '../informacoesCadastro/InformacoesDestinacaoUsoImovel'
import informacoesImovel from '../informacoesCadastro/InformacoesImovel'

import utils from '@/utils/utils'
import AppDivider from '../AppDivider'

export default {
  components: {
    AppDivider,
    informacoesDestinacaoUsoImovel,
    informacoesImovel
  },
  props: {
    imovel: {
      type: Object,
      required: true
    },
    cadastroOriginal: {
      type: Object,
      required: true
    }
  },
  methods: {
    filterNull (atributo) {
      return atributo !== null ? atributo : '-'
    },
    formatterNumber (value) {
      const options = {
        prefix: '',
        suffix: '',
        thousands: '.',
        decimal: ',',
        precision: 4
      }

      return utils.format(value, options)
    }
  }
}
</script>
<style lang="scss" scoped>
.label {
  font-weight: bold;
}
.pad {
  padding: 15px 5px;
}
.font14 {
  font-size: 14px;
}
.pad-top {
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/resumo/AppResumoImovelBeneficiario.vue